import { config } from '@/config';
import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoutButton from "./LogoutButton";

export default function Header() {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Dashboard', icon: '📊' },
    { path: '/bots', label: 'Bots', icon: '🤖' },
    { path: '/positions', label: 'Positions', icon: '💰' },
    { path: '/realtime', label: 'Realtime', icon: '📡' },
    { path: '/admin', label: 'Admin', icon: '⚙️' },
    { path: '/my-exchange', label: 'My Exchange', icon: '🔑' },
  ];

  return (
    <nav className="bg-gray-900 text-white shadow-lg">
      <div className="max-w-6xl mx-auto px-3 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-4">
            <h1 className="text-xl font-bold">NTheCloud Sentinel</h1>
            <span className="text-xs text-yellow-300 bg-blue-900 px-2 py-1 rounded font-mono">v1.0.4 - Build #4 - {new Date().toLocaleDateString()}</span>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                {item.icon} {item.label}
              </Link>
            ))}
            <LogoutButton />
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button className="text-gray-300 hover:text-white p-2">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        <div className="md:hidden pb-4">
          <div className="flex flex-col space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                {item.icon} {item.label}
              </Link>
            ))}
            <LogoutButton />
          </div>
        </div>
      </div>
    </nav>
  );
}
